import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { isGuardianUser } from "@/auth/navigationPersona";
import { usePermission } from "@/auth/permissions/usePermission";
import { Button } from "@/components/Button";
import { getBestAccessiblePath } from "@/navigation/bestAccessibleRoute";
import type { RootState } from "@/redux/store";

export function Forbidden() {
  const navigate = useNavigate();
  const { can } = usePermission();
  const user = useSelector((state: RootState) => state.auth.user);

  const bestPath = useMemo(() => {
    return getBestAccessiblePath(can, {
      preferredFeatureIds: ["dashboard"],
      fallbackPath: "/login",
      persona: isGuardianUser(user) ? "guardian" : "staff",
    });
  }, [can, user]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-white dark:bg-gray-900 px-4">
      <div className="max-w-md text-center">
        <p className="text-sm font-semibold text-red-600">403</p>
        <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-white">
          Access denied
        </h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
          You do not have permission to view this page. If you believe this is a mistake,
          please contact your administrator.
        </p>

        <div className="mt-6 flex items-center justify-center gap-3">
          <Button type="button" onClick={() => navigate(bestPath, { replace: true })}>
            Go to my home
          </Button>

          <Button type="button" variant="neutral" onClick={() => navigate(-1)}>
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
}
